import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "bar" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "getwell-name text-h4 pl-6 pt-7 pb-2 px-2" }, "Get Well", -1)
const _hoisted_3 = { class: "d-flex align-center py-1" }
const _hoisted_4 = { class: "v-list-item-icon" }
const _hoisted_5 = { class: "navigation-icon elevation-1 rounded-circle d-flex justify-center align-center" }
const _hoisted_6 = { class: "ml-2 v-list-item-content" }

import { ref } from "vue";
import useInterface from "../helpers/useInterface";
import MenuItem from "./MenuItem.vue";
import { NavigationRow } from "../types";
import palette from "@/guac-layout/styles/variables.module.scss";
// import "../App.scss";

interface Props {
  navOptions: NavigationRow[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderComponent',
  props: {
    navOptions: {}
  },
  setup(__props: any) {

const props = __props;
const drawer = ref(false);
const auth = useInterface("authInterface");
const navOptions = props.navOptions || useInterface("navOptions");

const navigate = (url: string, redirect: boolean) => {
  if (redirect) {
    // Nav Option may be a site that lives outside of GUAC boundary
    // ex: Inpatient Management Console
    // ex: Loop Admin
    window.open(url, "_blank");
  } else {
    window.history.pushState({}, "", url);
    drawer.value = false;
  }
};

const logout = () => {
  auth.logout();
};

return (_ctx: any,_cache: any) => {
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_v_layout = _resolveComponent("v-layout")!

  return (_openBlock(), _createBlock(_component_v_layout, {
    style: {"height":"55px"},
    class: "guac-layout-header"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_app_bar, {
        app: "",
        height: "55",
        class: "px-1",
        color: "#f6f5fb",
        style: { backgroundColor: 'rgb(246, 245, 251)' },
        "elevate-on-scroll": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_app_bar_nav_icon, {
            id: "layout-menu-button",
            class: "toggle-menu-button",
            icon: "mdi-dots-grid",
            size: "small",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (drawer.value = !drawer.value), ["stop"]))
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_navigation_drawer, {
        id: "sidebar",
        modelValue: drawer.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((drawer).value = $event)),
        width: "300",
        app: "",
        temporary: "",
        color: "white"
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _hoisted_2,
          _createVNode(_component_v_list, {
            class: "d-flex flex-column px-2",
            dense: "",
            nav: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navOptions), (item, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  ('launchPoint' in item)
                    ? (_openBlock(), _createBlock(MenuItem, {
                        key: index,
                        title: item.title,
                        icon: item.icon,
                        "id-suffix": item.path,
                        onClick: ($event: any) => (navigate(item.launchPoint, item.isRedirect))
                      }, null, 8, ["title", "icon", "id-suffix", "onClick"]))
                    : (_openBlock(), _createBlock(_component_v_list_group, {
                        key: 1,
                        value: item.name
                      }, {
                        activator: _withCtx(({ props: groupProps }) => [
                          (_openBlock(), _createBlock(MenuItem, _mergeProps({ ref_for: true }, { class: groupProps.class, onClick: groupProps.onClick }, {
                            key: item.name + index,
                            title: item.name,
                            icon: item.icon,
                            "id-suffix": item.name + '-group'
                          }), null, 16, ["title", "icon", "id-suffix"]))
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.items, (groupItem, groupItemIndex) => {
                            return (_openBlock(), _createBlock(MenuItem, {
                              key: groupItemIndex,
                              title: groupItem.title,
                              icon: groupItem.icon,
                              "id-suffix": groupItem.path,
                              onClick: ($event: any) => (navigate(groupItem.launchPoint, groupItem.isRedirect))
                            }, null, 8, ["title", "icon", "id-suffix", "onClick"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                ], 64))
              }), 128)),
              _createVNode(_component_v_spacer, { class: "pt-4" }),
              _createVNode(_component_v_list_item, {
                id: "layout-menu-item-logout",
                class: "sidebar-nav-option",
                style: _normalizeStyle({ color: _unref(palette).gwDarkPurple }),
                onClick: logout
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_v_icon, { color: "#5F6369" }, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-logout")
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Logout")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["style"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})